import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { commentM } from 'src/app/Models/BasicForms/commentM';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-comment-drawer',
  templateUrl: './comment-drawer.component.html',
  styleUrls: ['./comment-drawer.component.css'],
  providers: [DatePipe]
})

export class CommentDrawerComponent implements OnInit {
  @Input() drawerClose: Function;
  @Input() data: commentM;
  @Input() typeData: number;
  @Input() typeIDData: number;

  constructor(public _apiService: ApiService, private notificationService: NzNotificationService, private datePipe: DatePipe) { }

  ngOnInit(): void {
    this.loadAllTaggedUsers();
  }

  taggedUserList = [];
  loadAllTaggedUsers() {
    this._apiService.getAllUsers(0, 0, 'ID', 'desc', '').subscribe(userData => {
      this.taggedUserList = userData['data'];

    }, err => {

    });
  }

  isSpinning = false;
  logtext: string = "";

  save(addNew: boolean, commentPage: NgForm): void {
    var isOk = true;

    // if(this.data.COMMENT_DATETIME != undefined) {
    //   if(this.data.COMMENT_DATETIME== null) {
    //     isOk = false;
    //     this.notificationService.error("Please Select Commented Date Time","");
    //   }
    // }else {
    //   isOk = false;
    //   this.notificationService.error("Please Select Worked Date Time","");
    // }

    if (this.data.COMMENT_TEXT != undefined) {
      if (this.data.COMMENT_TEXT.trim() == "") {
        isOk = false;
        this.notificationService.error("Please Enter Valid Comment", "");
      }
    } else {
      isOk = false;
      this.notificationService.error("Please Enter Valid Comment", "");
    }

    if (isOk) {
      this.isSpinning = true;

      this.data.COMMENT_DATETIME = new Date();
      this.data.COMMENT_DATETIME = this.datePipe.transform(this.data.COMMENT_DATETIME, "yyyy-MM-dd HH:mm") + ":00";
      this.data.TYPE = this.typeData;
      this.data.TYPE_ID = this.typeIDData;
      this.data.TAGGED_USERS = this.data.TAGGED_USERS.toString();
      this.data.USER_ID = this._apiService.userId;
      this.data.IS_ACTIVE = true;



      if (!this.data.ID) {
        this._apiService.createComment(this.data).subscribe(successCode => {


          if (successCode['code'] == "200") {
            this.notificationService.success("Comment Added Successfully", "");

            if (!addNew) {
              this.drawerClose();
              this.resetDrawer(commentPage);

              this.logtext = 'Save & Close - Comment Master form - SUCCESS - ' + JSON.stringify(this.data) + " KEYWORD [C - Comment Master ]";
              this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
                if (successCode['code'] == "200") {

                }
                else {

                }
              });

            } else {
              this.data = new commentM();

              this.logtext = 'Save & New - Comment Master form - SUCCESS - ' + JSON.stringify(this.data) + " KEYWORD [C - Comment Master ]";
              this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
                if (successCode['code'] == "200") {

                }
                else {

                }
              });
            }
            this.isSpinning = false;

          } else {
            this.notificationService.error("Failed to Add Comment", "");
            this.logtext = 'Save & Close - Comment Master form - ERROR - ' + JSON.stringify(this.data) + " KEYWORD [C - Comment Master ]";
            this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
              if (successCode['code'] == "200") {

              }
              else {

              }
            });
          }

        }, err => {


          if (err["ok"] == false) {
            this.notificationService.error("Server Not Found", "");
          }
        });

      } else {
        this._apiService.updateComment(this.data).subscribe(successCode => {


          if (successCode['code'] == "200") {
            this.notificationService.success("Comment Updated Successfully", "");
            this.logtext = 'Update & Close - Comment Master form - SUCCESS - ' + JSON.stringify(this.data) + " KEYWORD [C - Comment Master ]";
            this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
              if (successCode['code'] == "200") {

              }
              else {

              }
            });

            this.isSpinning = false;
            this.drawerClose();

          } else {
            this.notificationService.error("Failed to Update Comment", "");
            this.logtext = 'Update & Close - Comment Master form - ERROR - ' + JSON.stringify(this.data) + " KEYWORD [C - Comment Master ]";
            this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
              if (successCode['code'] == "200") {

              }
              else {

              }
            });
          }

        }, err => {


          if (err["ok"] == false) {
            this.notificationService.error("Server Not Found", "");
          }
        });
      }
    }

    this.data.TAGGED_USERS = [];
  }

  close(commentPage: NgForm) {
    this.drawerClose();
    this.resetDrawer(commentPage);
  }

  resetDrawer(commentPage: NgForm) {
    this.isSpinning = false;
    commentPage.form.reset();
    this.data = new commentM();
  }
}
